<template>
    <div class="m-grid m-grid--hor m-grid--root m-page">
        <Loader></Loader>
        <div class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-1"
             id="m_login" v-bind:style="{ backgroundImage: 'url(' + image + ')' }">
            <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
                <div class="m-login__container">
                    <div class="m-login__logo">
                        <a href="#">
                            <img src="../../static/app/media/img/logos/logo-2.png"/>
                        </a>
                    </div>
                    <div class="m-login__signin">
                        <div class="m-login__head">
                            <h3 class="m-login__title">
                                {{$t('Sign In To Admin')}}
                            </h3>
                        </div>
                        <form class="m-login__form m-form" v-on:submit.prevent="login">
                            <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('email')}">
                                <input class="form-control m-input" type="text" :placeholder="$t('Email')" name="email"
                                       autocomplete="off" v-model="form.email">
                                <div class="form-control-feedback">
                        <span v-for="message in filter('email')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                                </div>
                            </div>
                            <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('password')}">
                                <input class="form-control m-input m-login__form-input--last" type="password"
                                       :placeholder="$t('Password')" name="password" v-model="form.password">
                                <div class="form-control-feedback">
                        <span v-for="message in filter('password')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                                </div>
                            </div>
                            <div class="m-login__form-action">
                                <button id="m_login_signin_submit"
                                        class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air  m-login__btn m-login__btn--primary">
                                    {{$t('Sign In')}}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from './core/Loader'
export default {
  name: 'Login',
  components: {Loader},
  data () {
    return {
      image: require('../../static/app/media/img/bg/bg-1.jpg'),
      form: {
        email: '',
        password: ''
      }
    }
  },
  created: function () {
    this.$store.commit('loading/change', false)
  },
  methods: {
    loadMenu () {
      this.apiUrl = process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/menu'

      this.$http
        .get(this.apiUrl + `/admin-menu`, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          self.menu = res.data.data
          self.loaded = 1

          this.$store.commit('loading/setMenu', self.menu)
          this.$router.push('/admin')
          /* location.reload()
          window.$('#m_ver_menu').customScrollbar({
            skin: 'default-skin',
            hScroll: false
          }) */
        }).catch(res => {
          this.$router.push('/login')
        })
    },
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    },
    login () {
      let v = new this.$validator.Validator()
      this.errors = v.checkValidation(this.$translate, this.form, [
        {
          input: 'email',
          error: 'email',
          name: 'Email',
          validations: [
            'required'
          ]
        },
        {
          input: 'password',
          error: 'password',
          name: 'Jelszó',
          validations: [
            'required'
          ]
        }
      ])

      if (JSON.stringify(this.errors) !== JSON.stringify({})) {
        this.$forceUpdate()
        return false
      }

      this.$store.commit('loading/change', true)
      this.$http
        .post(process.env.API_URL + '/oauth/token', {
          'grant_type': 'password',
          'client_id': process.env.CLIENT_ID,
          'client_secret': process.env.CLIENT_SECRET,
          'username': this.form.email.trim(),
          'password': this.form.password.trim(),
          'scope': '*'
        }).then(res => {
          localStorage.setItem('token', res.data.access_token)
          localStorage.setItem('refresh_token', res.data.refresh_token)
          this.loadMenu()
        }).catch(res => {

        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue